import cities from '../data/cities.json';

export type ServiceType = 
  | 'value-your-car'
  | 'sell-your-car'
  | 'instant-car-purchase'
  | 'car-inspection'
  | 'car-valuation'
  | 'sell-car-now';


interface ServiceConfig {
  path: string;
  title: string;
  description: string;
}

export const services: Record<ServiceType, ServiceConfig> = {
  'value-your-car': {
    path: 'value-your-car', 
    title: 'Value Your Car',
    description: 'Get an instant professional valuation for your car'
  },
  'sell-your-car': {
    path: 'sell-your-car',
    title: 'Sell Your Car',
    description: 'Get the best price for your car with our professional car buying service'
  },
  'instant-car-purchase': {
    path: 'instant-car-purchase',
    title: 'Instant Car Purchase',
    description: 'We buy your car instantly with same-day payment and free pickup'
  },
  'car-inspection': {
    path: 'car-inspection',
    title: 'Pre-Purchase Inspection',
    description: 'Professional vehicle inspection before we purchase your car'
  },
  'car-valuation': {
    path: 'car-valuation',
    title: 'Professional Car Valuation',
    description: 'Get an accurate market value for your vehicle from our experts'
  },
  'sell-car-now': {
    path: 'sell-car-now',
    title: 'Sell Car Now',
    description: 'Quick and hassle-free car selling process with instant payment'
  }
};

export const generateSeoRoutes = () => {
  const routes: { path: string; pattern: string; city: string; region: string; service: ServiceType }[] = [];
  
  Object.entries(services).forEach(([serviceKey, service]) => {
    cities.forEach(city => {
      const citySlug = city.toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

      routes.push({
        path: `/${service.path}-${citySlug}`,
        pattern: `/${service.path}-:city`,
        city: city,
        region: city,
        service: serviceKey as ServiceType
      });
    });
  });

  console.log('Generated Routes:', routes);
  return routes;
};

export const generateSitemap = () => {
  const baseUrl = 'https://sellcareasy.com.au';
  const routes = generateSeoRoutes();
  
  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>${baseUrl}</loc>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
  ${routes.map(route => `
  <url>
    <loc>${baseUrl}${route.path}</loc>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  `).join('')}
</urlset>`;

  return xml;
}; 